import { ProductLink } from '@portals/core/src/components/ProductLink/ProductLink';
import React from 'react';

import { LinkInternalLink } from '../../../models';
import { useLinkProps } from '../../hooks/useLinkProps';

interface Props {
  dividerLink?: LinkInternalLink;
}

export const DividerLink: React.FC<Props> = ({ dividerLink }: Props) => {
  const { singleProps } = useLinkProps(dividerLink);

  if (!dividerLink) {
    return null;
  }

  return <ProductLink {...singleProps}>{dividerLink.text}</ProductLink>;
};
